import styled from '@emotion/styled'

export const ContainerDateTime = styled('div')`
  text-align: center;
  font-size: 10px;
  font-weight: 400;
  color: #8a8a8a;
  margin-top: 7px;
`

export const DateText = styled('div')``

export const TimeText = styled('div')``
